import { createContext, useContext, useState } from "react";

const HomepageContext = createContext();

export function HomepageContextProvider({ children }) {
  const [activeSection, setActiveSection] = useState(null);

  return (
    <HomepageContext.Provider
      value={{
        activeSection,
        setActiveSection,
      }}
    >
      {children}
    </HomepageContext.Provider>
  );
}

export function useHomepageContext() {
  return useContext(HomepageContext);
}
